/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/autoCapitalizationFilter.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoAutoCapitalizationField implements angular.IDirective {
        restrict = "E";
        scope = {
            name: "@",
            currentValue: "=ngModel",
            contentKey: "@",
            disabled: "=ngDisabled",
            required: "=ngRequired",
            fieldFilter: "@",
            maxlength: "=?maxlength",
            minlength: "=?minlength",
            ngChange: "&ngChange",
            ngBlur: "&?ngBlur",
            tabIndex: "=?",
            //canClear: "=?",
            placeholder: "@?"
        };

        template =`
        <div>
            <div class="meevo_input_wrapper">
                <label translate="{{contentKey}}" aria-label="{{contentKey | translate}}"></label>
                <div ng-class="{'ng-dirty required_red_bubble ' : required && !currentValue}"></div>
            </div>
            <div style='position:relative;width:100%'>
                <input id="{{ contentKey + $parent.$index }}" autocomplete='off' ng-trim='false' ng-class="{' red_border_invalid' : (!currentValue && required)}" type="text" name="{{name}}" aria-label="{{contentKey | translate}}" title="{{contentKey | translate}}" ng-model="currentValue" ng-disabled="disabled" ng-required="required" maxlength="{{::maxlength}}" minlength="{{::minlength}}" ng-change="changeLocal();inputChanged()" ng-blur="ngBlur()" tabindex="{{tabIndex || 0}}" style="padding-right: 25px !important;" />
                <button class="meevo-typeahead-clearFilter" ng-disabled="disabled" ng-click="clear()" type="button" tabindex="-1"></button>
            </div>
        </div>`;

        constructor(
            private $filter: angular.IFilterService,
            private $compile: angular.ICompileService,
            private $timeout,
            private $translate: angular.translate.ITranslateService
        ) {
        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes, formCtrl: angular.IFormController) => {
            var filter = this.$filter;
            var timeout = this.$timeout;
            var input: any = element.find('input');
            if (scope.placeholder)
                input.attr("placeholder", this.$translate.instant(scope.placeholder));

            scope.fieldFilter = scope.fieldFilter ||  'meevoAutoCapitalization';

            attrs.$observe('fieldFilter', function (val) {
                if (angular.isDefined(val)) {
                    scope.fieldFilter = val;
                }
            });

            scope.changeLocal = function () {
                if (scope.ngChange) {
                    timeout(function () {
                        scope.ngChange();
                    });
                }
            }

            scope.clear = () => {
                input.focus();
                scope.currentValue = '';
                this.$timeout(() => {
                    if (angular.isDefined(scope.ngChange)) {
                        scope.ngChange();
                    }
                });
            }

            scope.inputChanged = () => {
                var newMaskedVal = filter(scope.fieldFilter)(scope.currentValue);;
                var cursorIndex = input.prop('selectionStart');

                if (scope.currentValue !== newMaskedVal) {

                    scope.currentValue = newMaskedVal;

                    // To prevent cursor jump (issue 63373) after setting new value, use timeout to set cursor position
                    if (cursorIndex < scope.currentValue.length) {
                        this.$timeout(() => {
                            input.prop({
                                'selectionStart': cursorIndex,
                                'selectionEnd': cursorIndex
                            });
                        });
                    }
                }
            }

            input.bind("blur", () => {
                if (Model.Guard.isSomething(scope.currentValue) && scope.fieldFilter === 'meevoAutoCapitalizationNameWithHyphenFilter') {
                    scope.currentValue = scope.currentValue.replace(/\-$/, "");
                    scope.$apply();
                }
            });
        }


        static factory(): angular.IDirectiveFactory {
            let directive = ($filter, $compile, $timeout, $translate) => {
                return new MeevoAutoCapitalizationField($filter, $compile, $timeout, $translate);
            };

            directive.$inject = ["$filter", "$compile", "$timeout", "$translate"];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoAutoCapitalizationField", MeevoAutoCapitalizationField.factory());
}
